import { render, staticRenderFns } from "./MyStaffForm.vue?vue&type=template&id=03906eeb&scoped=true"
import script from "./MyStaffForm.vue?vue&type=script&lang=js"
export * from "./MyStaffForm.vue?vue&type=script&lang=js"
import style0 from "./MyStaffForm.vue?vue&type=style&index=0&id=03906eeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03906eeb",
  null
  
)

export default component.exports